import { ENV } from '../../config/runtimeEnv';
import { ProteinStructureResponse } from '../../types/geneCodes/ProteinStructureTypes';
import { http } from '../../lib/http/client';

const API_BASE_URL = ENV.VITE_LABIQ_SERVER || '';

// Helper for common API headers

/**
 * Fetch the parsed structure of the protein a gene encodes. A gene with no published entry
 * resolves with found=false — that is a normal answer, not an error.
 */
export const fetchProteinStructure = async (geneName: string): Promise<ProteinStructureResponse> => {
	const response = await http.get(`${API_BASE_URL}/protein-structure/${encodeURIComponent(geneName)}`);
	return response.data;
};

/** Fetch a known PDB entry directly, bypassing the gene lookup. */
export const fetchProteinStructureByPdbId = async (pdbId: string): Promise<ProteinStructureResponse> => {
	const response = await http.get(`${API_BASE_URL}/protein-structure/entry/${encodeURIComponent(pdbId)}`);
	return response.data;
};
